/**
 * Helper function to take a string or number and round it to a certain number of decimal places
 * @param num number to round
 * @param precision how many decimal places to round to
 * @returns rounded number
 */
export function roundDecimal(num: string | number, precision = 2) {
  try {
    num = parseFloat(num as string);
  } catch (e) {
    return num;
  }
  const factor = Math.pow(10, precision);
  return Math.round(num * factor) / factor;
}

/**
 * Returns a label for the given direction type.
 * @param directionType The numeric code of the direction type.
 * @returns A string representing the label of the direction type, or null if unrecognized.
 */
export function getDirectionTypeLabel(directionType: number): string {
  switch (directionType) {
    case 1:
      return "Put";
    case 2:
      return "Pick";
    case 3:
      return "Return";
    case 4:
      return "Transfer";
    case 5:
      return "Count";
    default:
      return null;
  }
}
